import { createContext, useContext } from 'react'

/**
 * Who's signed in, as `/me` describes them — `{ isAdmin, accountant }`.
 * Admins can act everywhere. Accountants can view the admin screens but not
 * act on them (the backend enforces the same), except uploading a client's
 * statement and working their own fixes on My Ledgers.
 */
export const AccessContext = createContext({ isAdmin: false, accountant: null })

/** True when the signed-in person can take actions on the admin screens. */
export const useCanAct = () => Boolean(useContext(AccessContext)?.isAdmin)
